'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _CouponStore = require('./CouponStore');

var _CouponStore2 = _interopRequireDefault(_CouponStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELIVERY = "Delivery";
var PICKUP = "PickUp";
var CURBSIDEPICKUP = "CurbsidePickUp";
var DINEIN = "DineIn";

var CustomChargeStore = _reflux2.default.createStore({
    listenables: [_Actions2.default],
    init: function init() {
        this._chargeConfig = [];
        this._deliveryCharges = [];
        this._pickupCharges = [];
        this._curbsidePickupCharges = [];
        this._dineInCharges = [];
        this._orderTypes = ["Delivery", "PickUp", "CurbsidePickUp", "DineIn"];
    },


    // get locationDetailPointer object
    onMainDataCustom: function onMainDataCustom(_data) {

        var self = this;

        if (_data && _data.LocationDetail) {

            var locationDetail = _data.LocationDetail;

            var chargeConfig = locationDetail.chargeConfig;

            if (locationDetail && chargeConfig && chargeConfig.length > 0) {

                // load the custom charges
                self._chargeConfig = chargeConfig;

                // Filter the custom charge data with order type
                self.filterCustomCharges();
            } else {

                // Clear the custom charge state
                self.clearCustomChargeStore();
            }
        }
    },
    filterCustomCharges: function filterCustomCharges() {

        var self = this;
        var orderTypes = this._orderTypes;

        orderTypes.forEach(function (element) {

            // get the filtered charges based on order type
            var filteredCharges = self.arrangeByOrderType(element);

            if (element == DELIVERY) {
                self._deliveryCharges = filteredCharges;
            } else if (element == PICKUP) {
                self._pickupCharges = filteredCharges;
            } else if (element == CURBSIDEPICKUP) {
                self._curbsidePickupCharges = filteredCharges;
            } else if (element == DINEIN) {
                self._dineInCharges = filteredCharges;
            } else {
                // not found any order type
            }
        });
    },
    arrangeByOrderType: function arrangeByOrderType(type) {

        var self = this;

        // get the charge config array of charges
        var chargeConfig = self._chargeConfig;

        // filter the charges based on order types and active status
        var filteredArray = chargeConfig.filter(function (charge) {

            var status = charge.active;
            if (status) {
                var orderTypes = charge.orderTypes;

                return orderTypes.some(function (orderType) {
                    return orderType == type;
                });
            }
        });

        return filteredArray;
    },
    isCustomChargeConfigured: function isCustomChargeConfigured() {

        var self = this;

        if (self.getDeliveryChargesLength() > 0) {
            return true;
        } else if (self.getPickUpChargesLength() > 0) {
            return true;
        } else if (self.getCurbsidePickUpChargesLength() > 0) {
            return true;
        } else if (self.getDineInChargesLength() > 0) {
            return true;
        } else {
            return false;
        }
    },
    getDeliveryChargesLength: function getDeliveryChargesLength() {

        var self = this;

        if (self._deliveryCharges.length > 0) {
            return self._deliveryCharges.length;
        } else {
            return 0;
        }
    },
    getPickUpChargesLength: function getPickUpChargesLength() {

        var self = this;

        if (self._pickupCharges.length > 0) {
            return self._pickupCharges.length;
        } else {
            return 0;
        }
    },
    getCurbsidePickUpChargesLength: function getCurbsidePickUpChargesLength() {

        var self = this;

        if (self._curbsidePickupCharges.length > 0) {
            return self._curbsidePickupCharges.length;
        } else {
            return 0;
        }
    },
    getDineInChargesLength: function getDineInChargesLength() {

        var self = this;

        if (self._dineInCharges.length > 0) {
            return self._dineInCharges.length;
        } else {
            return 0;
        }
    },
    getCustomChargeConfig: function getCustomChargeConfig(orderType, chargeType) {

        var self = this;

        var customChargeData = void 0;

        if (orderType == DELIVERY) {
            customChargeData = self._deliveryCharges;
        } else if (orderType == PICKUP) {
            customChargeData = self._pickupCharges;
        } else if (orderType == CURBSIDEPICKUP) {
            customChargeData = self._curbsidePickupCharges;
        } else if (orderType == DINEIN) {
            customChargeData = self._dineInCharges;
        } else {
            customChargeData = [];
        }

        if (customChargeData && customChargeData.length > 0) {

            var filteredArray = customChargeData.filter(function (charge) {

                var status = charge.active;
                if (status) {
                    return charge.type == chargeType;
                }
            });

            return filteredArray;
        } else {
            return null;
        }
    },
    getChargePercentage: function getChargePercentage(valuesArray) {

        if (valuesArray && valuesArray.length > 0) {

            var objValue = valuesArray[0];

            var varValue = objValue.var;

            return varValue;
        } else {
            return 0;
        }
    },
    getChargeFixed: function getChargeFixed(valuesArray) {

        if (valuesArray && valuesArray.length > 0) {

            var objValue = valuesArray[0];

            var fixedValue = objValue.fixed;

            return fixedValue;
        } else {
            return 0;
        }
    },
    getCustomChargeFeeRounded: function getCustomChargeFeeRounded(chargeTypeValues, totalValue) {

        var chargePercentage = this.getChargePercentage(chargeTypeValues);
        var chargeFixed = this.getChargeFixed(chargeTypeValues);

        var totalChargeFee = 0;

        if (chargePercentage && chargePercentage != 0) {

            totalChargeFee = totalValue * chargePercentage / 100;
        }

        if (chargeFixed && chargeFixed != 0) {
            totalChargeFee = totalChargeFee + chargeFixed;
        }

        var digit = 2;
        return _lodash2.default.round(totalChargeFee, digit).toFixed(digit);
    },
    showPercentageOrFixed: function showPercentageOrFixed(chargeTypeValue) {

        if (chargeTypeValue != null) {

            var stringPercentage = null;
            if (chargeTypeValue.var != 0) {
                stringPercentage = chargeTypeValue.var + "% of Sub Total";
            }

            var stringFixed = null;
            if (chargeTypeValue.fixed != 0) {
                stringFixed = "$" + chargeTypeValue.fixed;
            }

            var stringPerFixed = "";
            if (stringPercentage != null) {
                stringPerFixed = stringPercentage;
            }

            if (stringFixed != null) {

                if (Utils.isEmpty(stringPerFixed)) {
                    stringPerFixed = stringFixed;
                } else {
                    stringPerFixed = stringPerFixed.concat(" + " + stringFixed);
                }
            }

            return stringPerFixed;
        }

        return null;
    },
    getCalculateFeeOfCharge: function getCalculateFeeOfCharge(chargeTypeValue, totalValue) {

        if (chargeTypeValue != null) {

            var totalFee = 0;
            if (chargeTypeValue.var != 0) {
                var totalPer = chargeTypeValue.var;

                var totalPerValue = totalValue * totalPer / 100;

                totalFee = _lodash2.default.round(totalPerValue, 2);
            }

            if (chargeTypeValue.fixed != 0) {
                var totalFixed = chargeTypeValue.fixed;

                totalFee = totalFee + totalFixed;
            }

            return _lodash2.default.round(totalFee, 2).toFixed(2);
        }

        return 0;
    },
    clearCustomChargeStore: function clearCustomChargeStore() {

        this._chargeConfig = [];
        this._deliveryCharges = [];
        this._pickupCharges = [];
        this._curbsidePickupCharges = [];
        this._dineInCharges = [];
    }
}

// triggerCustomChargesChange() {
//
//     const customChargeObj = {
//         // deliveryCharges         : this._deliveryCharges,
//         // pickupCharges           : this._pickupCharges,
//         // curbsidePickupCharges   : this._curbsidePickupCharges,
//         // dineInCharges           : this._dineInCharges,
//         // fixedChargeValue        : this._fixedChargeValue,
//         // // defaultOptionalCharge   : this._defaultOptionalCharge,
//         // appliedCharge1          : this._appliedCharge1,
//         // appliedCharge2          : this._appliedCharge2,
//         // appliedCharge3          : this._appliedCharge3,
//         // roundOffStatus          : this._roundOffStatus,
//         // roundOffValue          : this._roundOffValue
//     };
//     this.trigger('change', customChargeObj);
// }
);

exports.default = CustomChargeStore;


//////////////////
// WEBPACK FOOTER
// ./src/stores/CustomChargeStore.jsx
// module id = 418
// module chunks = 0